import { DashboardLayout } from 'lib-dashboard-types';
import { QueueWithAssignmentCounts } from 'lib-shared-types-api';
import { createContext, useContext } from 'react';

export type QueueDashboardQueueContextValue = {
  /**
   * The optional queue the metrics are associated with. If not provided, the
   * metric is a global aggregate metric of all queues.
   */
  queue?: QueueWithAssignmentCounts;
  /** Whether to show the skeleton UI, e.g. when loading. */
  isSkeleton?: boolean;
  /** The preferred dashboard layout. */
  layout?: DashboardLayout;
};

export const QueueDashboardQueueContext =
  createContext<QueueDashboardQueueContextValue>(undefined!);

export const useQueueDashboardQueueContext =
  (): QueueDashboardQueueContextValue => {
    return useContext(QueueDashboardQueueContext);
  };
